import axios from "axios";
import { ACCESS_TOKEN } from "../lib/cookie";

export const TEMP_TOKEN_KEY = "tempSessionToken";
export const TEMP_VIEWER_NAME_KEY = "tempViewerAnonymousName";
export const TEMP_VIEWER_PASSWORD_KEY = "tempViewerAnonymousPassword";

export const hasTempViewerSession = () => {
  if (typeof window === "undefined") return false;
  return !!sessionStorage.getItem(TEMP_TOKEN_KEY);
};

// 협력 사이트(OCSPST)에서 게스트 티켓으로 들어온 세션 (탭 단위, 30분)
export const PARTNER_TOKEN_KEY = "partnerGuestToken";
export const PARTNER_EXPIRES_AT_KEY = "partnerGuestExpiresAt";
export const PARTNER_POST_ID_KEY = "partnerGuestPostId";

export interface PartnerGuestSession {
  token: string;
  postId: number;
  expiresAt: number; // epoch ms
}

export const clearPartnerGuestSession = () => {
  sessionStorage.removeItem(PARTNER_TOKEN_KEY);
  sessionStorage.removeItem(PARTNER_EXPIRES_AT_KEY);
  sessionStorage.removeItem(PARTNER_POST_ID_KEY);
};

// 만료된 세션은 지우고 null 반환
export const getPartnerGuestSession = (): PartnerGuestSession | null => {
  if (typeof window === "undefined") return null;
  const token = sessionStorage.getItem(PARTNER_TOKEN_KEY);
  const expiresAt = Number(sessionStorage.getItem(PARTNER_EXPIRES_AT_KEY));
  const postId = Number(sessionStorage.getItem(PARTNER_POST_ID_KEY));
  if (!token || !expiresAt || !postId) return null;
  if (expiresAt <= Date.now()) {
    clearPartnerGuestSession();
    return null;
  }
  return { token, postId, expiresAt };
};

const buildAuthHeaders = (contentType: string) => {
  const tempToken = sessionStorage.getItem(TEMP_TOKEN_KEY);
  if (tempToken) {
    return { "Content-Type": contentType, "X-Temp-Token": tempToken };
  }
  const partnerSession = getPartnerGuestSession();
  if (partnerSession) {
    return { "Content-Type": contentType, "X-Partner-Token": partnerSession.token };
  }
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  return {
    "Content-Type": contentType,
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
};

export const api = () =>
  axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL + "/api",
    headers: buildAuthHeaders("application/json"),
  });

export const wildApi = () =>
  axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL + "/api",
    headers: buildAuthHeaders("*"),
    responseType: "blob",
  });

export const formDataApi = () =>
  axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL + "/api",
    headers: buildAuthHeaders("multipart/form-data"),
  });

export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + "/api",
  headers: { "Content-Type": "application/json" },
});


export const deepzoomApi = axios.create({
  baseURL: process.env.REACT_APP_DEEPZOOM_URL,
});
